module.exports = __webpack_public_path__ + "img/1F1E8-1F1F2.7dd76f38.svg";